<div class="sidenav" [ngClass]="{'collapsed-sidebar': isCollapsed, 'sidebar': !isCollapsed}">
    <mat-drawer-container class="drawer-container">
        <mat-drawer class="drawer side-bar-class" mode="side" opened>
            <div class="drawer__header">
                <div class="drawer__header--icon">
                    <div class="hamburger-menu">
                        <mat-icon class="chevron-button" [ngClass]="{'rotated': isCollapsed}"
                            (click)="toggleSidebar()">chevron_left</mat-icon>
                    </div>
                    <img class="ps4-icon" src="assets/images/sect4-logo.svg" alt="Primaria Sectorului 4" />
                    <div class="drawer__header--text">
                        <div class="drawer__header--text--title">{{appName}}</div>
                        <div class="drawer__header--text--title--minWidth">PS 4</div>
                        <div class="drawer__header--text--subtitle faded-text">
                            {{appDescription}}
                        </div>
                        <div class="drawer__header--text--subtitle--minWidth faded-text">
                            inMot 4
                        </div>
                    </div>
                    <div class="drawer__header--social-container">
                        <div class="drawer__header--social" (click)="redirectToinDeskPlatform()">
                            <i class="fa-solid fa-desktop pointer" style="color: #fff"></i>
                            <span class="drawer__header--social--text faded-text pointer">inDesk</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="drawer__buttons">
                <mat-accordion>
                    <p *ngIf="permissionsService.hasPermission('monitoring-module.proiecte.list')" class="menu-link"
                        routerLink="/proiecte" [class.menu-active]="'/proiecte' === activeOption"
                        (click)="setActive('/proiecte')">
                        <img src="../../../assets/icons/docs.svg" alt="" />
                        <span>Proiecte</span>
                    </p>
                    <p class="menu-link"
                        routerLink="/push-notifications-proiecte" [class.menu-active]="'/push-notifications-proiecte' === activeOption"
                        (click)="setActive('/push-notifications-proiecte')">
                        <img src="../../../assets/icons/docs.svg" alt="" />
                        <span>Push Notifications Proiecte</span>
                    </p>
                    <p *ngIf="
                            permissionsService.hasPermission('monitoring-module.proiecte.categorii.list') ||
                            permissionsService.hasPermission('monitoring-module.proiecte.sectiuni.list') ||
                            permissionsService.hasPermission('monitoring-module.proiecte.tag.list') ||
                            permissionsService.hasPermission('monitoring-module.proiecte.provider.list') ||
                            permissionsService.hasPermission('monitoring-module.proiecte.agent.list') ||
                            permissionsService.hasPermission('monitoring-module.proiecte.motiv-delay.list') ||
                            permissionsService.hasPermission('monitoring-module.proiecte.proiecte-status.list')
                        " class="menu-link" routerLink="/setari-proiecte"
                        [class.menu-active]="'/setari-proiecte' === activeOption"
                        (click)="setActive('/setari-proiecte')">
                        <img src="../../../assets/icons/setari.svg" alt="" />
                        <span>Setări Proiecte</span>
                    </p>

                    <!-- <mat-expansion-panel class="sidenav-accordion" (opened)="panelOpenState = true"
                        (closed)="panelOpenState = false">
                        <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState">
                            <mat-panel-title class="sidenav-accordion">
                                <div class="panel-title">
                                    <img src="../../../assets/icons/docs.svg" alt="" />
                                    <span>Proiecte</span>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p class="settings-option-menu" routerLink="/proiecte"
                            [class.menu-active]="'/proiecte' === activeOption" (click)="setActive('/proiecte')">
                            <img src="../../../assets/icons/docs.svg" alt="" />
                            <span>Proiecte</span>
                        </p>
                        <p class="settings-option-menu" routerLink="/setari-proiecte"
                            [class.menu-active]="'/setari-proiecte' === activeOption"
                            (click)="setActive('/setari-proiecte')">
                            <img src="../../../assets/icons/setari.svg" alt="" />
                            <span>Setări Proiecte</span>
                        </p>
                    </mat-expansion-panel> -->
                </mat-accordion>

                <div class="footer">
                    <div class="logout-button" (click)="logout()">
                        <img src="assets/icons/logout.svg" alt="Deconectare" />
                        <div click="logout()" class="logout-button--text">Deconectare</div>
                    </div>
                </div>
            </div>
        </mat-drawer>
        <mat-drawer-content class="drawer-content" [style.marginLeft.px]="isCollapsed ? 85 : 280">
            <router-outlet></router-outlet>
        </mat-drawer-content>
    </mat-drawer-container>
</div>